"use client";

import { useTranslations } from "next-intl";
import { Container } from "@/components/ui/Container";
import { CtaButton } from "@/components/ui/CtaButton";
import { Reveal } from "@/components/Reveal";
import { site } from "@/lib/site";

// "Ook voor je normale treinritten betaal je te veel" section. Each proof card
// shows one big savings number with a short explanation and CTA.
export function MoreServices() {
  const t = useTranslations("More");

  const cards = [
    {
      key: "subscription",
      savings: t("card1Savings"),
      title: t("card1Title"),
      body: t("card1Body"),
      cta: t("card1Cta"),
      href: site.loginUrl,
      linkId: "more_subscription",
    },
    {
      key: "checkout",
      savings: t("card2Savings"),
      title: t("card2Title"),
      body: t("card2Body"),
      cta: t("card2Cta"),
      href: site.loginUrl,
      linkId: "more_checkout",
    },
  ];

  const cardBase =
    "relative flex flex-col rounded-3xl bg-white ring-1 ring-gray-950/5";

  return (
    <section className="py-12 lg:py-20" data-track-section="more_services">
      <Container>
        <div className="relative -mx-5 overflow-hidden rounded-none bg-linear-to-b from-mist via-[#eef4ff] to-[#dbe8ff] px-5 py-14 sm:mx-0 sm:rounded-[2rem] sm:px-10 lg:px-14 lg:py-20">
          <Reveal className="mx-auto max-w-2xl text-center">
            <h2 className="text-3xl font-extrabold tracking-tight text-balance text-navy sm:text-4xl">
              {t("title")}
            </h2>
          </Reveal>

          <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-7">
            {cards.map((c) => (
              <Reveal key={c.key} className={`${cardBase} p-8 text-center sm:p-10`}>
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-success-dark">
                  {t("savingsLead")}
                </p>
                <p className="mt-2 text-6xl font-extrabold tracking-tight text-success-dark tabular-nums sm:text-7xl">
                  {c.savings}
                </p>
                <h3 className="mx-auto mt-5 max-w-xs text-lg font-bold text-balance text-navy">
                  {c.title}
                </h3>
                <p className="mx-auto mt-3 max-w-sm text-sm text-pretty text-slate">
                  {c.body}
                </p>
                <div className="mt-auto pt-8">
                  <CtaButton href={c.href} linkId={c.linkId} size="md" className="w-full">
                    {c.cta}
                  </CtaButton>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
